import { useEffect, useMemo, useState } from "react";
import { Flex, Form, Input, Skeleton } from "antd";
import { CustomButton } from "ui";
import { addMailLayout, getMailLayout } from "services/settingsService";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { parseErrorMessage, _isRequired } from "utils";
import { DataStoreConstructor } from "stores/core/DataStoreConstructor";
import { observer } from "mobx-react-lite";

const { TextArea } = Input;

type MailLayoutDto = Awaited<ReturnType<typeof getMailLayout>>;

interface MailEditModalProps {
  onClose: () => void;
}

export const MailEditModal = observer(({ onClose }: MailEditModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { openNotification } = useNotificationContext();

  const mailLayoutStore = useMemo(
    () =>
      new DataStoreConstructor<MailLayoutDto>({
        fetchMethod: getMailLayout,
        defaultData: { html: "" },
      }),
    []
  );

  const { data: mailData, statuses: mailStatuses, fetch: fetchMail } = mailLayoutStore;

  useEffect(() => {
    fetchMail();
  }, [fetchMail]);

  useEffect(() => {
    if (mailData?.html) {
      form.setFieldsValue({ html: mailData.html });
    }
  }, [mailData, form]);

  const handleSubmit = async (values: { html: string }) => {
    setLoading(true);
    try {
      await addMailLayout(values);
      openNotification({
        message: "Шаблон успешно обновлен",
        type: NOTIFICATION_TYPE_ENUM.SUCCESS,
      });
      fetchMail();
      onClose();
    } catch (error: any) {
      openNotification({
        description: parseErrorMessage(error),
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  if (mailStatuses.loading) {
    return <Skeleton active paragraph={{ rows: 23 }}/>;
  }

  return (
    <Form form={form} className="full-width" onFinish={handleSubmit} initialValues={{ html: mailData?.html || "" }}>
      <Flex vertical gap="large">
        <Flex vertical>
          <Form.Item name="html" rules={[_isRequired("Поле обязательно для заполнения")]}>
            <TextArea rows={36} placeholder="Содержимое email шаблона" />
          </Form.Item>
        </Flex>

        <Form.Item>
          <Flex gap="large" className="margin-top-xs">
            <CustomButton htmlType="button" className="full-width" type="default" onClick={onClose} disabled={loading}>
              Отменить
            </CustomButton>
            <CustomButton htmlType="submit" className="full-width" loading={loading}>
              Сохранить изменения
            </CustomButton>
          </Flex>
        </Form.Item>
      </Flex>
    </Form>
  );
});
